import React, {Component} from 'react'
import {BrowserRouter} from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import ReactCSSTransitionGroup from 'react-transition-group/CSSTransition'
import {sendUserEventToParent} from '../actions/static'

import {
  getPersistentMenuApi,
  getWidgetSettings,
  sendOpenedGreeting,
  sendSentGreeting,
  sendAction,
} from '../api/api'
import StartPopup from '../components/startPopup/StartPopup'
import Container from '../components/containers/Container/Container'
import StartScreen from '../components/containers/StartScreen/StartScreen'
import Button from '../components/button/Button'
import {
  checkIsRightButtonNeeded,
  detectUserLanguageOrDefault,
  initialDatePickerSettings,
  initialIframeSetting,
  initialImageModalSettings,
  startHeight,
  startWidth,
  transitionSettingsContainer,
  transitionSettingsLauncher
} from './config'
import widgetStorage from '../actions/storage'
import {generaneUuid} from '../helper/generaneUuid'

import {setAPIUrl} from '../config/config'
import {
  checkBoolFromString,
  getBotMessage,
  getIframeSettingsFromBrowserByHistoryLevel,
  getIsIframeOpen,
  isUndefined,
  setIsIframeOpen,
  toBoolean
} from '../actions/static'
import { EMPOWERPOST, EMPOWERPRE, HORIZONPOST, PANORAMAPOST } from '../constants/string'

import classes from './styles.module.scss'
import './App.css'
import { CountUnreadMessagesProvider } from '../context/CountUnreadMessagesContext'
import { WebSocketsProviders } from '../context/WebSocketsContext'
import EndPopup from '../components/startPopup/EndPopup'
import {actionType} from "../constants/messageActionType";
import { getFocusables } from '../helper/getFocusables'
import { userActionEvents } from '../constants/userActionEvents'
import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum-slim'

class App extends Component {
  constructor(props) {
    super(props)
    this.myRef = React.createRef()

    this.state = {
      user: null,
      chatId: null,
      init: false,
      messages: [],
      uuid: generaneUuid(),
      widgetInfo: {},
      settings: {},
      mobile: false,
      showLoader: false,
      isUserIdle: false,
      authorized: false,
      openWidget: false,
      parentOrigin: null,
      persistentMenu: null,
      parentURL: false,
      isNeedCloseWidget: false,
      shouldShowClosePopupScheduleGCText: false,
      isCloseWidgetModalOpened: false,
      hasPersistentMenu: true,
      websiteLocation: '',
      settingsUpdated: false,
      showStartScreen: false,
      autoExpand: false,
      isMaximized: false,
      isFirst: true,
      isTextDisabled: false,
      isFullScreenWidget: false,
      isHorizonPost: false,
      isPanoramaPost: false,
      popupAfterWidgetClose: false,
      popupBeforeWidgetOpen: false,
      isEmpowerPre: false,
      isEmpowerPost: false,
      isEndOfConversation: false,
      iframeSettings: initialIframeSetting,
      imageModalSettings: initialImageModalSettings,
      datePickerSettings: initialDatePickerSettings,
      autofilledText: null,
      isMobile: false,
      device: {
        width: 0,
        height: 0
      },
      popupWasShown: false,
      isHiddenWidget: true,
      firstUnreadMessageId: null,
      isSoundNotification: true,
      avatarLogo: '',
      isImageZoomed: false,
      passedOrSkippedFlowComponentsId: [],
      needToDisconnectWebSocketsConnection: false,
      isOpenSwitchLanguageModal: false,
      widgetIframeSource: null,
      startTiming: null,
      widgetLoadedStartTiming: null,
      isDDRumTimingSent: false
    }
  }

  componentDidMount() {
    const isOpen = widgetStorage.isWidgetOpened()

    this.setState(
      {
        isHiddenWidget: !isOpen,
      },
      () => {
        window.addEventListener('message', this.messageEventListener.bind(this))
        document.addEventListener('keydown', this.keydownListener.bind(this))
        this.initializeWidget()
      },
    )
    this.checkDisplayInputField()
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      botId,
      parentOrigin,
      init,
      settingsUpdated,
      openWidget,
      showStartScreen,
      isMaximized,
      popupBeforeWidgetOpen,
      popupAfterWidgetClose,
      isNeedCloseWidget,
      isCloseWidgetModalOpened,
      iframeSettings
    } = this.state

    const { unreadMessagesList } = this.props

    const isShouldFrameResize =
        (popupAfterWidgetClose !== prevState.popupAfterWidgetClose) ||
        (popupBeforeWidgetOpen !== prevState.popupBeforeWidgetOpen) ||
        openWidget !== prevState.openWidget ||
        showStartScreen !== prevState.showStartScreen ||
        isMaximized !== prevState.isMaximized ||
        unreadMessagesList !== prevProps?.unreadMessagesList

    const chatId = widgetStorage.tryFindChatIdInAnyStorage()

    if (isShouldFrameResize) {
      this.updateFrameSize()
    }
    if ((prevState.parentOrigin !== parentOrigin) ||
        (prevState.init !== init) || (prevState.settingsUpdated !== settingsUpdated)) {
      if (parentOrigin && !init && settingsUpdated) {
        this.initialFunction()
      }
    }

    if (openWidget !== prevState.openWidget) {
      const {iframeSrc} = iframeSettings
      if (iframeSrc) {
        const url = new URL(iframeSrc)
        url.searchParams.set('preventSendEvent', 'true')
        this.setIframe({
          ...iframeSettings,
          iframeSrc: url.toString()
        })
      }
    }

    if (showStartScreen !== prevState.showStartScreen && showStartScreen && chatId) {
      sendAction(actionType.WELCOME_SCREEN_OPEN, botId, chatId)
    }

    if (isNeedCloseWidget && !isCloseWidgetModalOpened) {
      this.setState({
        isCloseWidgetModalOpened: true
      })
    }
  }

  componentWillUnmount() {
    const {popupBeforeDelayTimeout, popupAfterDelayTimeout} = this.state
    if (popupBeforeDelayTimeout) clearTimeout(popupBeforeDelayTimeout)
    if (popupAfterDelayTimeout) clearTimeout(popupAfterDelayTimeout)
  }

  initializeWidget() {
    window.parent.postMessage(//NOSONAR
      {
        type: 'widget-set-url',
      },
      '*',
    )
  }

  keydownListener(e) {
    const { openWidget } = this.state

    if (e.key === 'Tab' && openWidget) {
      const bodyContainer = document.getElementsByTagName('body')[0]
      const currentTarget = e.target
      const focusData = getFocusables(bodyContainer, currentTarget)
      const lastFocusableElementIndex = focusData.focusables.length - 1
      this.setState({ currentFocusIndex: focusData.focusIndex + 1 })
      this.setState({ focusData })

      if (e.shiftKey) {
        this.setState({ currentFocusIndex: focusData.focusIndex - 1 })
        if (!focusData.focusIndex) {
          e.preventDefault()
          focusData.focusables[lastFocusableElementIndex].focus()
        }
      } else {
        if (focusData.focusIndex === lastFocusableElementIndex) {
          e.preventDefault()
          focusData.focusables[0].focus()
        }
      }
    }
  }

  initialFunction() {
    const { settings, isMobile } = this.state
    const { greeting } = settings
    const chatId = widgetStorage.tryFindChatIdInAnyStorage()

    const needUserInformation = settings.isLoginEmailInputEnabled || settings.isLoginNameInputEnabled
    const authorized =
      !needUserInformation || (chatId && widgetStorage.isEnabled())

    if (window.location.search.includes('open=true') && !needUserInformation) {
      this.setState(
        {
          isFullScreenWidget: !isMobile,
          openWidget: true,
          init: true,
          authorized,
        },
        () => this.resizeWidget(!isMobile),
      )
    } else if (((isMobile && settings.showPopupMessagesInMobile) || !isMobile) && greeting) {
      const popupBeforeDelayTimeout = setTimeout(() => {
        if (!this.state.openWidget) {
          this.setState({ popupBeforeWidgetOpen: true, popupWasShow: true }, () => {
            const chatId = widgetStorage.tryFindChatIdInAnyStorage()
            sendSentGreeting(this.state.botId, greeting.hash)
          })
        }
      }, greeting.delaySeconds * 1000)
      this.setState({
        init: true,
        authorized,
        popupBeforeDelayTimeout,
      })
    } else {
      this.setState({
        init: true,
        authorized,
      }, () => this.checkIfActiveIframeSrc())

    }
  }

  setIsNeedCloseWidget = (value, shouldShowClosePopupScheduleGCText) => {
    this.setState({
      isNeedCloseWidget: value,
      shouldShowClosePopupScheduleGCText: toBoolean(shouldShowClosePopupScheduleGCText)
    })
  }

  showPopupAfterCloseWidget() {
    const {settings, openWidget, isMobile} = this.state
    const {
      widgetPopupDelayOnClosing,
      showPopupMessagesInMobile,
      popupMessageOnClosing,
      showPopupMessageOnClosing
    } = settings

    const popupIsNeeded = !openWidget
      && popupMessageOnClosing
      && showPopupMessageOnClosing
      && ((isMobile && showPopupMessagesInMobile) || !isMobile)

    if (popupIsNeeded) {
      const popupAfterDelayTimeout = setTimeout(() => {
        this.setState({popupAfterWidgetClose: true})
      }, widgetPopupDelayOnClosing * 1000)

      this.setState({popupAfterDelayTimeout})
    }
  }


  messageEventListener(event) {
    if (event.data.type === 'widget' && event.data.uuid === this.state.uuid) {
      this.widgetEventListener(event)
    }

    if (
      event.data.type === 'initialization' &&
      event.data.uuid === this.state.uuid
    ) {
      this.configureWidget(event)
    }

    if (event.data.type === 'page-url-changed') {
      setAPIUrl(event.data.serverUrl)
      this.pageUrlListener(event)
    }

    if (event.data.type === 'language-changed') {
      const { botId, chatId } = this.state
      const { languageCode } = event.data
      const language = detectUserLanguageOrDefault(languageCode)

      !chatId && this.updateWidget(language)
      sendAction(actionType.BOT_LOADER_LANGUAGE_SWITCHED, botId, chatId, { languageCode: language })
    }

    if (event.data.type === 'reset-chat-history') {
      this.resetChat()
    }

    if (event.data.type === 'portal_expire') {
      this.state.isImageZoomed && window.parent.postMessage({
        type: 'widget-close-image'
      }, '*')

      this.setInputField({isTextDisabled: true})
      this.setState({
        isUserIdle: true,
        isNeedCloseWidget: false,
        isImageZoomed: false,
        messages: [getBotMessage(this.state.settings.idleMessage)]
      })
    }

    if (event.data.type === 'widget-close-image') {
      this.setIsImageZoomed(false)
    }

    if (event.data.type === 'widget-resize-callback') {
      this.toggleAuthorized()
    }

    if (event.data.type === 'widget-close-websocket-connection') {
      this.setState({
        needToDisconnectWebSocketsConnection: true
      })
    }

    if (event.data.type === 'widget-clear-localstorage') {
      widgetStorage.clearStorage(this.state.botId)
    }
  }

  setIsImageZoomed = isZoomed => {
    this.setState({isImageZoomed: isZoomed})
  }

  setParentOrigin = origin => {
    this.setState({
      parentOrigin: origin || document.location.origin
    })
  }

  configureWidget = event => {
    this.setParentOrigin(event.origin)
    this.setUserLanguage(event.data.languageCode)
    this.setWidget(event.data)
  }

  updateFrameSize() {
    const {openWidget, isMaximized, popupBeforeWidgetOpen, popupAfterWidgetClose} = this.state

    window.parent.postMessage({
      type: 'widget-resize',
      isOpen: openWidget,
      isMaximized: isMaximized,
      isPopupOpen: popupBeforeWidgetOpen || popupAfterWidgetClose
    }, '*')
  }

  toggleAuthorizedByCallback() {
    window.parent.postMessage({
      type: 'widget-resize-callback',
      isOpen: !this.state.openWidget,
      isMaximized: this.state.isMaximized,
      isPopupOpen: false
    }, '*')

    window.parent.postMessage({
      type: 'widget-parent-scroll',
      isOpenWidget: !this.state.openWidget
    }, '*')
  }

  resetChat = () => {
    this.setState(
      {
        chatId: null,
        openWidget: false,
        authorized: false,
        showStartScreen: false,
        isFullScreenWidget: false,
        user: null,
        messages: [],
      },
      () => {
        widgetStorage.clearStorage(this.state.botId)
        this.resizeWidget(false)
      },
    )
  }
  widgetEventListener = event => {
    let { parentOrigin, isMobile, device, chatId, parentURL } = this.state
    if (event.data.isMobile) {
      isMobile = event.data.isMobile
      device = {
        width: event.data.device.width,
        height: event.data.device.height,
      }
    }
    if (!this.state.chatId && widgetStorage.tryFindChatIdInAnyStorage()) {
      chatId = widgetStorage.tryFindChatIdInAnyStorage()
    }
    if (event.origin !== parentOrigin) {
      parentOrigin = event.origin || document.location.origin
    }
    if (parentURL !== event.data.parentURL) {
      parentURL = event.data.parentURL
    }

    this.setState({
      device,
      isMobile,
      parentURL,
      parentOrigin,
      chatId
    })
  }

  pageUrlListener = event => {
    window.parent.postMessage(
      {
        width: startWidth,
        height: startHeight,
        needId: true,
        type: 'widget-initialization',
        uuid: this.state.uuid,
      },
      event.data.url,
    )

    setAPIUrl(event.data.serverUrl)
    this.setState(
      {
        websiteLocation: event.data.url,
      })
  }

  setFrameSize(newWidth, newHeight) {
    const { showStartScreen, isMobile, openWidget, parentOrigin, isMaximized } = this.state

    window.parent.postMessage(
      {
        type: 'widget',
        uuid: this.state.uuid,
        width: newWidth,
        height: newHeight,
        needDelay: showStartScreen && isMobile,
        isPlacedInTheCenter: openWidget && isMaximized
      },
      parentOrigin,
    )
  }

  getSettings = (widgetInfo, language) => {
    return { ...widgetInfo, ...widgetInfo.languageConfigs[language] }
  }

  setWidget = async ({ botId, neva_token_id, patientInfo, autoExpand, isMaximized, isMobile, device, isFirst, heapIoIdentity, heapIoPrefix, attributes, languageCode, startTiming }) => {
    this.setState({
      nevaPreSessionToken: neva_token_id,
      patientInfo
    })
    if (!botId) {
      return
    }
    widgetStorage.clearStorage(botId);
    const chatId = widgetStorage.findChatIdInAnyStorage(botId)
    const currentLanguage = detectUserLanguageOrDefault(languageCode)
    widgetStorage.configureBotId(botId)

    const widgetInfo = await getWidgetSettings(botId)

    const settings = this.getSettings(widgetInfo, currentLanguage)

    if (!settings) {
      return
    }

    this.saveAvatarImageToState(settings)
    widgetStorage.configure(settings.chatHistoryLevel, botId)

    if (!widgetStorage.tryFindChatIdInAnyStorage()) {
      this.setInputField({isTextDisabled: settings.isComposerInputEnabled})
    }

    widgetStorage.setChatId(chatId);

    this.setState({
      chatId,
      attributes,
      widgetInfo,
      settings,
      botId:settings.botId,
      hasPersistentMenu: settings.hasPersistentMenu,
      settingsUpdated: true,
      autoExpand,
      isMaximized,
      isFirst,
      heapIoIdentity,
      heapIoPrefix,
      isMobile,
      device,
      isSoundNotification: settings?.widgetSettings?.doEnableSoundNotifications,
      startTiming,
    }, () => {
      if (autoExpand) {
        this.toggleWidget()
      }
      if (settings.botName.toLowerCase() === EMPOWERPRE) {
        this.setState({
          isEmpowerPre: true
        })
      }
      if (settings.botName.toLowerCase() === EMPOWERPOST) {
        this.setState({
          isEmpowerPost: true
        })
      }
      if (settings.botName.toLowerCase() === HORIZONPOST) {
        this.setState({
          isHorizonPost: true
        })
      }
      if (settings.botName.toLowerCase() === PANORAMAPOST) {
        this.setState({
          isPanoramaPost: true
        })
      }
      sendUserEventToParent(isFirst ? userActionEvents.BOT_LOADED_FIRST : userActionEvents.BOT_LOADED_NTH)
      datadogRum.addRumGlobalContext('autoExpand', autoExpand)
    })

  }

  saveAvatarImageToState = (settings) => {
    const {avatarLogo} = this.state
    const imageUrl = settings?.logo

    if (imageUrl && !avatarLogo) {
      fetch(imageUrl)
        .then((res) => res.blob())
        .then(blob => {
          const file = new FileReader()
          file.onload = () => {
            this.setState({
              avatarLogo: file.result
            })
          }
          file.readAsDataURL(blob) //need to generate correct exception
        })
        .catch(error => {
          datadogLogs.logger.error("Error to fetch image", error)
        })
    }
  }

  updateWidget = (language) => {
    const { widgetInfo } = this.state

    const settings = this.getSettings(widgetInfo, language)

    this.setUserLanguage(language)
    this.setState({
      settings,
      isSoundNotification: settings?.widgetSettings?.doEnableSoundNotifications,
    })
  }

  setPersistentMenu = (botId, chatId) => {
    if (botId && chatId) {
      getPersistentMenuApi(botId)
        .then(persistentMenu => {
          this.setState({ persistentMenu })
        })
        .catch(console.error)
    }
  }

  setInputField = ({isTextDisabled, defaultText}) => {
    this.setState({isTextDisabled, autofilledText: defaultText}, () => {
      localStorage.setItem('widget-inputEnable', String(isTextDisabled))
    })
  }

  checkDisplayInputField = () => {
    const isTextDisabled = checkBoolFromString(localStorage.getItem('widget-inputEnable'))
    if (isTextDisabled) {
      this.setState({isTextDisabled})
    }
  };

  openStartScreen = () => {
    widgetStorage.setIsWidgetOpened(false)
    this.toggleBackground(false)
    this.setState({
      isHiddenWidget: false,
      showStartScreen: true,
      popupBeforeWidgetOpen: false,
      popupAfterWidgetClose: false
    })
  }
  hideStartScreen = () => {
    this.setState({ showStartScreen: false })
  }

  toggleAuthorized = () => {
    this.setState(
      {
        popupBeforeWidgetOpen: false,
        popupAfterWidgetClose: false,
        openWidget: !this.state.openWidget,
        isHiddenWidget: !this.state.openWidget ? false : this.state.isHiddenWidget,
      },
      () => {
        this.openWidget(this.state.openWidget && this.state.autoExpand)
        if (!this.state.openWidget) {
          this.showPopupAfterCloseWidget()
        } else {
          clearTimeout(this.state.popupAfterDelayTimeout)
        } this.toggleBackground(this.state.openWidget)
        widgetStorage.setIsWidgetOpened(this.state.openWidget)
      },
    )
  }

  toggleUnauthorized = () => {
    const { showStartScreen, popupAfterDelayTimeout } = this.state
    if (showStartScreen) {
      this.hideStartScreen()
      this.showPopupAfterCloseWidget()
    } else {
      widgetStorage.setIsWidgetOpened(false)
      this.toggleBackground(false)
      clearTimeout(popupAfterDelayTimeout)
      this.openStartScreen()
    }
  }

  setHasPersistentMenu = hasPersistentMenu => {
    this.setState({
      hasPersistentMenu
    })
  }

  setIsCloseWidgetModalOpened = isCloseWidgetModalOpened => {
    this.setState({
      isCloseWidgetModalOpened
    })
  }

  updatePersistentMenu = newMenu => {
    this.setState({
      persistentMenu: newMenu
    })
  }

  resizeWidget = isMaximized => {
    if (!this.state.isCloseWidgetModalOpened) {
      this.setState({
        isMaximized
      }, () => {
        if (this.state.settings.isBackgroundBlurred) {
          this.toggleBackground(isMaximized)
        }
      })
    }
  }

  openWidget = autoExpand => {
    this.setState({
      autoExpand
    })
  }

  toggleWidget = () => {
    const { authorized, settings, popupBeforeDelayTimeout, widgetLoadedStartTiming } = this.state
    if (!widgetLoadedStartTiming) {
      this.setState({
        widgetLoadedStartTiming: Date.now()
      })
    }
    widgetStorage.setIsWidgetOpenedIfNull(true)

    const needUserInformation =
      settings.isLoginNameInputEnabled ||
      settings.isLoginEmailInputEnabled
    if (needUserInformation && !authorized) {
      this.toggleUnauthorized()
    } else {
      this.toggleAuthorizedByCallback()
    }
    if (popupBeforeDelayTimeout) {
      clearTimeout(popupBeforeDelayTimeout)
    }
  }

  toggleBackground = isBackgroundEnable => {
    const { settings, isMaximized, openWidget } = this.state
    if (!settings.isBackgroundBlurred && !settings.isBackgroundDimmed) return

    if (settings.isBackgroundBlurred) {
      window.parent.postMessage({
        type: 'widget-background-blurred',
        background: isBackgroundEnable && isMaximized,
        isPlacedInTheCenter: openWidget && isMaximized
      }, '*')
    }

    if (settings.isBackgroundDimmed) {
      window.parent.postMessage({
        type: 'widget-background-dark',
        background: isBackgroundEnable,
        isPlacedInTheCenter: openWidget && isMaximized
      }, '*')
    }
  }

  closeWidget = () => {
    this.setState(
      {
        openWidget: false,
      },
      () => {
        this.toggleBackground(this.state.openWidget)
        widgetStorage.setIsWidgetOpened(this.state.openWidget)
        this.openWidget(false)
      },
    )
  }

  updateMessages = (newMessages, callback, isOldMessages) => {
    if (newMessages && newMessages.length > 0) {
      if (isOldMessages) {
        return this.setState(
          prevState => ({ messages: newMessages.concat(prevState.messages) }),
          () => {
            if (callback) callback()
          },
        )
      }
      return this.setState(
        prevState => ({ messages: prevState.messages.concat(newMessages) }),
        () => {
          if (callback) callback()
        },
      )
    }
  }

  updateUserData = user => {
    this.setState(
      {
        user,
        showStartScreen: false,
        openWidget: true,
        authorized: true,
      },
      () => {
        widgetStorage.setIsWidgetOpened(true)
        this.toggleBackground(true)
      },
    )
  }

  setUserLanguage = (languageCode) => {
    const { i18n } = this.props
    const language = detectUserLanguageOrDefault(languageCode)

    i18n.changeLanguage(language)

    this.setState({
      user: {
        language,
      },
    })
  }

  setIsEndOfConversation = (isEndOfConversation) => {
    return this.setState({isEndOfConversation})
  };

  submitPopup = (isEndPopup) => {
    this.setState(
      {
        popupBeforeWidgetOpen: false,
        popupAfterWidgetClose: false
      },
      () => {
        if (!isEndPopup) {
          const chatId = widgetStorage.tryFindChatIdInAnyStorage()
          sendOpenedGreeting(this.state.botId, this.state.settings.greeting.hash, chatId)
        }
        this.toggleWidget()
      },
    )
  }
  closePopup = () => {
    this.setState({
      popupBeforeWidgetOpen: false,
      popupAfterWidgetClose: false
    })
  }

  handleLoader = (showLoader, callback) => {
    this.setState({ showLoader }, callback && callback())
  }

  checkIfActiveIframeSrc = iframeSettings => {
    const {
      settings: { chatHistoryLevel: chatHistoryLevel, activeIframeSrc },
    } = this.state
    const activeIframeSettings =
      getIframeSettingsFromBrowserByHistoryLevel(chatHistoryLevel)
    const isIframeOpenPropExists = !isUndefined(iframeSettings && iframeSettings.isIframeOpen)
    const isIframeOpen = isIframeOpenPropExists
      ? iframeSettings.isIframeOpen
      : toBoolean(getIsIframeOpen())
    const settings = { isIframeOpen }

    if (activeIframeSrc) settings.iframeSrc = activeIframeSrc
    if (activeIframeSettings && activeIframeSettings.questionnaireName)
      settings.questionnaireName = activeIframeSettings.questionnaireName

    this.handleLoader(isIframeOpen, () => this.setIframe(settings))
  }

    setClickableChat = isClickableChat => {
      this.setState({
        isClickableChat
      })
    }

  setIframe = ({
    isLoaded,
    iframeSrc,
    isIframeOpen,
    questionnaireName,
    opportunityToManualClose,
    isQuestionnaireIframeOpened,
  }) => {
    const {
      settings: { chatHistoryLevel: chatHistoryLevel },
    } = this.state
    const settings = Object.assign({}, this.state.iframeSettings)

    settings.isLoaded = !isUndefined(isLoaded) ? isLoaded : settings.isLoaded
    settings.iframeSrc = !isUndefined(iframeSrc)
      ? iframeSrc
      : settings.iframeSrc
    settings.isIframeOpen = !isUndefined(isIframeOpen)
      ? isIframeOpen
      : settings.isIframeOpen
    settings.questionnaireName = !isUndefined(questionnaireName)
      ? questionnaireName
      : settings.questionnaireName
    settings.opportunityToManualClose = !isUndefined(opportunityToManualClose)
      ? opportunityToManualClose
      : settings.opportunityToManualClose
    settings.isQuestionnaireIframeOpened = !isUndefined(opportunityToManualClose)
      ? isQuestionnaireIframeOpened
      : settings.isQuestionnaireIframeOpened

    this.setState(
      {
        iframeSettings: settings,
        showLoader: isLoaded,
      },
      () => setIsIframeOpen(chatHistoryLevel, isIframeOpen),
    )
  }

  setImageModalSettings = ({ imageModalSrc, imageAltText }) => {
    this.setState({
      imageModalSettings: { imageModalSrc, imageAltText }
    })
  }

  setDatePickerSettings = (datePickerSettings) => {
    this.setState({ datePickerSettings })
  }

  handleHiddenWidget = () => {
    this.setState({ isHiddenWidget: true }, this.toggleWidget)
  }

  handleViewWidget = () => {
    this.setState({ isHiddenWidget: false }, this.toggleWidget)
  }

  setFirstUnreadMessageId = message => {
    this.setState({ firstUnreadMessageId: message })
  }

  handleSoundNotification = () => {
    this.setState({ isSoundNotification: !this.state.isSoundNotification })
  }

  replaceMessages = (messages) => {
    this.setState({messages})
  }

  setPassedOrSkippedFlowComponentsId = (passedComponentId) => {
    this.setState(prevState => ({
      passedOrSkippedFlowComponentsId: [...prevState.passedOrSkippedFlowComponentsId, passedComponentId]
    }))
  }

  updateMessagesState = (id, value, target) => {
    const { messages } = this.state
    const newMessages = messages.map(message => {
      if (message.id === id) {
        message[target].selectedValue = value
        return message
      } else {
        return message
      }
    })
    this.setState({ messages: newMessages })
  }

  setIsDDRumTimingSent = (isDDRumTimingSent) => {
    this.setState({ isDDRumTimingSent })
  }

  updateDisablingButtonsByPersistentMenuUse = () => {
    const { messages } = this.state
    const messagesCopy = [...messages]
    const reversedMessages = messagesCopy.reverse()
    const disablingMessage = reversedMessages.find(message => message.rating || message.dropdown)
    const disablingButton = disablingMessage?.buttons.find(button => button.type === 'rating' || button.type === 'dropdown')
    if (disablingButton) {
      this.setPassedOrSkippedFlowComponentsId(disablingButton.id)
    }
  }

  setIsOpenSwitchLanguageModal = (value) =>{
    this.setState({
      isOpenSwitchLanguageModal: value
    })
  }

  setWidgetIframeSource = (source) => {
    this.setState({
      widgetIframeSource: source
    })
  }

  setChatId = (chatId) => {
    this.setState({ chatId })
  }

  render() {
    const {
      init,
      nevaPreSessionToken,
      patientInfo,
      user,
      botId,
      chatId,
      isMobile,
      messages,
      settings,
      device,
      isUserIdle,
      parentURL,
      isEmpowerPre,
      isEmpowerPost,
      isPanoramaPost,
      openWidget,
      authorized,
      attributes,
      autoExpand,
      parentOrigin,
      isTextDisabled,
      hasPersistentMenu,
      persistentMenu,
      iframeSettings,
      websiteLocation,
      settingsUpdated,
      showStartScreen,
      isFullScreenWidget,
      isNeedCloseWidget,
      showLoader,
      isIframeOpen,
      isMaximized,
      autofilledText,
      isCloseWidgetModalOpened,
      isEndOfConversation,
      popupBeforeWidgetOpen,
      popupWasShow,
      isHiddenWidget,
      firstUnreadMessageId,
      isSoundNotification,
      avatarLogo,
      shouldShowClosePopupScheduleGCText,
      imageModalSettings,
      datePickerSettings,
      heapIoIdentity,
      heapIoPrefix,
      passedOrSkippedFlowComponentsId,
      needToDisconnectWebSocketsConnection,
      isOpenSwitchLanguageModal,
      widgetIframeSource,
      startTiming,
      widgetLoadedStartTiming,
      isDDRumTimingSent
    } = this.state

    const isWidgetNotOpened = !authorized ? !showStartScreen : !openWidget
    const isStartPopupNeeded =
      init && popupBeforeWidgetOpen && !showStartScreen && !openWidget

    const isButtonNeeded = checkIsRightButtonNeeded(
      openWidget,
      autoExpand,
    )
    return (
      <>
        {settingsUpdated && (
          <div
            ref={this.myRef}
            className={classes.widgetWrap}>
            <BrowserRouter basename="/">

              <CountUnreadMessagesProvider
                isSoundNotification={isSoundNotification}>
                <WebSocketsProviders
                  nevaPreSessionToken={nevaPreSessionToken}
                  patientInfo={patientInfo}
                  user={user}
                  botId={botId}
                  messages={messages}
                  greeting={settings.greeting}
                  settings={settings}
                  isUserIdle={isUserIdle}
                  openWidget={openWidget}
                  attributes={attributes}
                  isPanoramaPost={isPanoramaPost}
                  parentOrigin={parentOrigin}
                  websiteLocation={websiteLocation}
                  isEndOfConversation={isEndOfConversation}
                  heapIoIdentity={heapIoIdentity}
                  heapIoPrefix={heapIoPrefix}
                  setIsEndOfConversation={this.setIsEndOfConversation}
                  closeWidget={this.closeWidget}
                  toggleWidget={this.toggleWidget}
                  setInputField={this.setInputField}
                  updateMessages={this.updateMessages}
                  persistentMenu={persistentMenu}
                  hasPersistentMenu={hasPersistentMenu}
                  setHasPersistentMenu={this.setHasPersistentMenu}
                  updateWidget={this.updateWidget}
                  setIsNeedCloseWidget={this.setIsNeedCloseWidget}
                  setIsOpenSwitchLanguageModal={this.setIsOpenSwitchLanguageModal}
                  updatePersistentMenu={this.updatePersistentMenu}
                  checkIfActiveIframeSrc={this.checkIfActiveIframeSrc}
                  isDisplayChatHistory={settings.chatHistoryLevel}
                  welcomeAtomPayload={settings.welcomeAtomPayload}
                  firstUnreadMessageId={firstUnreadMessageId}
                  setFirstUnreadMessageId={this.setFirstUnreadMessageId}
                  isHiddenWidget={isHiddenWidget}
                  popupWasShow={popupWasShow}
                  replaceMessages={this.replaceMessages}
                  needToDisconnectWebSocketsConnection={needToDisconnectWebSocketsConnection}
                  widgetIframeSource={widgetIframeSource}
                  setChatId={this.setChatId}
                  resetChat={this.resetChat}
                >
                  <>
                    {openWidget && (
                      <ReactCSSTransitionGroup {...transitionSettingsContainer}>
                        <Container
                          chatId={chatId}
                          isMobile={isMobile}
                          messages={messages}
                          settings={settings}
                          isUserIdle={isUserIdle}
                          iframeSettings={iframeSettings}
                          setIframe={this.setIframe}
                          imageModalSettings={imageModalSettings}
                          setImageModalSettings={this.setImageModalSettings}
                          datePickerSettings={datePickerSettings}
                          setDatePickerSettings={this.setDatePickerSettings}
                          parentURL={parentURL}
                          isTextDisabled={isTextDisabled}
                          hasPersistentMenu={hasPersistentMenu}
                          persistentMenu={persistentMenu}
                          autofilledText={autofilledText}
                          setClickableChat={this.setClickableChat}
                          resizeWidget={this.resizeWidget}
                          toggleWidget={this.toggleWidget}
                          updateMessages={this.updateMessages}
                          isFullScreenWidget={isFullScreenWidget}
                          isNeedCloseWidget={isNeedCloseWidget}
                          showLoader={showLoader}
                          isIframeOpen={isIframeOpen}
                          setIsNeedCloseWidget={this.setIsNeedCloseWidget}
                          closePopupText={settings?.closePopupText}
                          closePopupScheduleGCText={settings?.closePopupScheduleGCText}
                          shouldShowClosePopupScheduleGCText={shouldShowClosePopupScheduleGCText}
                          keepChattingButtonText={settings?.keepChattingButtonText}
                          closeChatButtonText={settings?.closeChatButtonText}
                          isMaximized={isMaximized}
                          isPanoramaPost={isPanoramaPost}
                          isEmpowerPre={isEmpowerPre}
                          isEmpowerPost={isEmpowerPost}
                          isCloseWidgetModalOpened={isCloseWidgetModalOpened}
                          setIsCloseWidgetModalOpened={this.setIsCloseWidgetModalOpened}
                          firstUnreadMessageId={firstUnreadMessageId}
                          setFirstUnreadMessageId={this.setFirstUnreadMessageId}
                          handleSoundNotification={this.handleSoundNotification}
                          avatarLogo={avatarLogo}
                          setIsImageZoomed={this.setIsImageZoomed}
                          updateMessagesState={this.updateMessagesState}
                          passedOrSkippedFlowComponentsId={passedOrSkippedFlowComponentsId}
                          setPassedOrSkippedFlowComponentsId={this.setPassedOrSkippedFlowComponentsId}
                          startTiming={startTiming}
                          widgetLoadedStartTiming={widgetLoadedStartTiming}
                          isDDRumTimingSent={isDDRumTimingSent}
                          setIsDDRumTimingSent={this.setIsDDRumTimingSent}
                          updateDisablingButtonsByPersistentMenuUse={this.updateDisablingButtonsByPersistentMenuUse}
                          isOpenSwitchLanguageModal={isOpenSwitchLanguageModal}
                          setIsOpenSwitchLanguageModal={this.setIsOpenSwitchLanguageModal}
                          switchLanguagePopupText={settings?.switchLanguagePopupText}
                          continueSwitchingLanguageButtonText={settings?.continueSwitchingLanguageButtonText}
                          cancelSwitchingLanguageButtonText={settings?.cancelSwitchingLanguageButtonText}
                          widgetIframeSource={widgetIframeSource}
                          setWidgetIframeSource={this.setWidgetIframeSource}
                          language={user.language}
                        />
                      </ReactCSSTransitionGroup>
                    )}
                    {showStartScreen && (
                      <ReactCSSTransitionGroup {...transitionSettingsContainer}>
                        <StartScreen
                          authorized={authorized}
                          greeting={settings.greeting}
                          device={device}
                          showPopup={popupBeforeWidgetOpen}
                          settings={settings}
                          updateUserData={this.updateUserData}
                          popupWasShow={popupWasShow}
                        />
                      </ReactCSSTransitionGroup>
                    )}
                    <ReactCSSTransitionGroup {...transitionSettingsLauncher}>
                      {isButtonNeeded && (
                        <div className={classes.rightBottomPositioned}>
                          {isStartPopupNeeded && (
                            <StartPopup
                              device={device}
                              greeting={settings.greeting}
                              authorized={authorized}
                              showStartScreen={showStartScreen}
                              closePopup={this.closePopup}
                              submitPopup={this.submitPopup}
                            />
                          )}
                          {this.state.popupAfterWidgetClose && (
                            <ReactCSSTransitionGroup {...transitionSettingsLauncher}>
                              <EndPopup
                                text={ isEndOfConversation ? settings?.popupMessageOnClosingEndChat : settings?.popupMessageOnClosing }
                                closePopup={this.closePopup}
                                submitPopup={this.submitPopup}
                              />
                            </ReactCSSTransitionGroup>
                          )}
                          {!openWidget &&
                            <Button
                              botId={botId}
                              greeting={settings.greeting}
                              settings={settings}
                              showPopup={popupBeforeWidgetOpen}
                              authorized={authorized}
                              showStartScreen={showStartScreen}
                              isWidgetOpened={isWidgetNotOpened}
                              toggleWidget={this.toggleWidget}
                              isHiddenWidget={isHiddenWidget}
                              handleViewWidget={this.handleViewWidget}
                            />
                          }
                        </div>
                      )}
                    </ReactCSSTransitionGroup>
                  </>
                </WebSocketsProviders>
              </CountUnreadMessagesProvider>

            </BrowserRouter>
          </div>
        )}
      </>
    )
  }
}

export default withTranslation()(App)
